var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _line, _line2, _line3, _line4, _g9, _line5, _line6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoResultsInMarketDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 371,
    height: 334,
    viewBox: "0 0 371 334",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1521_64094)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.196 89.8311H275.953C279.449 89.8311 282.283 92.6652 282.283 96.1613V250.365C282.283 253.861 279.449 256.695 275.953 256.695H158.156C154.66 256.695 151.826 253.861 151.826 250.365V146.383",
    stroke: "#807ED2",
    strokeWidth: 1.89908,
    strokeLinecap: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter1_d_1521_64094)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.2449 58.188C36.2449 63.3075 32.3255 67.3689 27.5972 67.3689C22.869 67.3689 18.9495 63.3075 18.9495 58.188C18.9495 53.0686 22.869 49.0072 27.5972 49.0072C32.3255 49.0072 36.2449 53.0686 36.2449 58.188Z",
    stroke: "#807ED2",
    strokeWidth: 1.89908,
    strokeLinecap: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter2_d_1521_64094)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 261.663,
    cy: 299.964,
    r: 13.4463,
    stroke: "#807ED2",
    strokeWidth: 1.89908,
    strokeLinecap: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter3_d_1521_64094)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 322.919,
    cy: 35.9192,
    r: 13.4463,
    transform: "rotate(83.5625 322.919 35.9192)",
    stroke: "#807ED2",
    strokeWidth: 1.89908,
    strokeLinecap: "round"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter4_d_1521_64094)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297.243 259.089L306.751 258.65L311.885 266.665L307.511 275.118L298.003 275.557L292.869 267.543L297.243 259.089Z",
    stroke: "#807ED2",
    strokeWidth: 1.89908,
    strokeLinecap: "round"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter5_d_1521_64094)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.093 199.705L73.5951 209.103L66.2067 215.103L57.3163 211.705L55.8141 202.306L63.2025 196.306L72.093 199.705Z",
    stroke: "#807ED2",
    strokeWidth: 1.89908,
    strokeLinecap: "round"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter6_d_1521_64094)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.1 101.556L338.085 93.4481L347.599 93.7117L352.128 102.083L347.143 110.191L337.628 109.927L333.1 101.556Z",
    stroke: "#807ED2",
    strokeWidth: 1.89908,
    strokeLinecap: "round"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter7_d_1521_64094)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80.8121,
    y: 16.1629,
    width: 32.1733,
    height: 32.1733,
    transform: "rotate(15 80.8121 16.1629)",
    stroke: "#807ED2",
    strokeWidth: 1.89908,
    strokeLinecap: "round"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 199.95,
    y1: 121.05,
    x2: 241.05,
    y2: 121.05,
    stroke: "#807ED2",
    strokeWidth: 1.89908,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 182.95,
    y1: 141.05,
    x2: 214.05,
    y2: 141.05,
    stroke: "#807ED2",
    strokeWidth: 1.89908,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 170.95,
    y1: 160.05,
    x2: 255.05,
    y2: 160.05,
    stroke: "#807ED2",
    strokeWidth: 1.89908,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 170.95,
    y1: 179.05,
    x2: 210.05,
    y2: 179.05,
    stroke: "#807ED2",
    strokeWidth: 1.89908,
    strokeLinecap: "round"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_1521_64094)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 151.5,
    cy: 90.5,
    r: 41.5505,
    stroke: "#807ED2",
    strokeWidth: 1.89908,
    strokeLinecap: "round"
  }))), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 166.193,
    y1: 77.1827,
    x2: 138.345,
    y2: 105.031,
    stroke: "#807ED2",
    strokeWidth: 1.89908,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 0.949541,
    y1: -0.949541,
    x2: 40.3325,
    y2: -0.949541,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 137.002 75.8398)",
    stroke: "#807ED2",
    strokeWidth: 1.89908,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1521_64094",
    x: 133.784,
    y: 74.3222,
    width: 166.54,
    height: 202.946,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.53211
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54587
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.337255 0 0 0 0 0.32549 0 0 0 0 0.823529 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1521_64094"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1521_64094",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1521_64094",
    x: 0.908258,
    y: 33.498,
    width: 53.3781,
    height: 54.4442,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.53211
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54587
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.337255 0 0 0 0 0.32549 0 0 0 0 0.823529 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1521_64094"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1521_64094",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1521_64094",
    x: 230.176,
    y: 271.009,
    width: 62.9752,
    height: 62.9755,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.53211
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54587
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.337255 0 0 0 0 0.32549 0 0 0 0 0.823529 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1521_64094"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1521_64094",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1521_64094",
    x: 291.43,
    y: 6.96283,
    width: 62.9777,
    height: 62.9774,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.53211
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54587
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.337255 0 0 0 0 0.32549 0 0 0 0 0.823529 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1521_64094"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1521_64094",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_1521_64094",
    x: 274.682,
    y: 243.117,
    width: 55.3895,
    height: 53.038,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.53211
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54587
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.337255 0 0 0 0 0.32549 0 0 0 0 0.823529 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1521_64094"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1521_64094",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_1521_64094",
    x: 37.6983,
    y: 180.664,
    width: 54.0126,
    height: 55.1464,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.53211
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54587
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.337255 0 0 0 0 0.32549 0 0 0 0 0.823529 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1521_64094"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1521_64094",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_1521_64094",
    x: 314.912,
    y: 77.9238,
    width: 55.4042,
    height: 52.8554,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.53211
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54587
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.337255 0 0 0 0 0.32549 0 0 0 0 0.823529 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1521_64094"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1521_64094",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_1521_64094",
    x: 54.2303,
    y: 0.440368,
    width: 75.9135,
    height: 75.914,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.53211
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54587
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.337255 0 0 0 0 0.32549 0 0 0 0 0.823529 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1521_64094"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1521_64094",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_1521_64094",
    x: 91.9083,
    y: 33.4404,
    width: 119.183,
    height: 119.183,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.53211
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54587
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.337255 0 0 0 0 0.32549 0 0 0 0 0.823529 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1521_64094"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1521_64094",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResultsInMarketDark);
export default __webpack_public_path__ + "static/media/no-results-in-market-dark.7f44441b6a5afd7b7b3141f8bf0e604f.svg";
export { ForwardRef as ReactComponent };